// extracted by mini-css-extract-plugin
module.exports = {"card":"Agiles_card__ZcuLh","logo":"Agiles_logo__1AA9W"};